<template>
  <div class="upload-img">
    <!-- 上传 -->
    <div class="chuan">
      <!-- 上传的图片 -->
      <div class="uploadList"
           v-if="uploadList&&uploadList.length!=0">
        <div class="imgList"
             v-for="(item,index) in uploadList"
             :key="index">
          <img :src="$publicData.ossUrl+item.url" />
          <!-- 放大删除 -->
          <div class="icon">
            <Icon type="ios-eye-outline"
                  @click="tobig(index)" />
            <Icon type="ios-trash-outline"
                  @click="todelect(index)" />
          </div>
        </div>
      </div>
      <!-- 上传图标 -->
      <div class="uploadw"
           v-show="!uploadList||(uploadList.length<=9)">
        <input type="file"
               accept="image/*"
               ref="uploadFile"
               title
               id="fileImage"
               name="fileImage"
               @change="showImg"
               @click="tofile" />
        <img src="/statics/console/img/chuanIcon.png" />
      </div>
    </div>
    <!-- <Alert v-if="defaultTip != ''">{{ defaultTip }}-剪裁尺寸：{{autoCropWidth}}*{{autoCropHeight}}</Alert> -->
    <Alert v-if="defaultTip != ''">{{ defaultTip }},最大3M</Alert>
    <!-- 剪裁插件 -->
    <Modal class="cai-tan"
           title="剪裁图片"
           v-model="showCai"
           style="text-align:center"
           @on-ok="handleClick"
           @on-cancel="toqu"
           :closable="false"
           :mask-closable="false">
      <div style="display:flex;align-items: end;">
        <div class="cropper"
             :style="{width: `${imgObj.width}px`, height: `${imgObj.height}px`}"
             v-if="showCai">
          <vueCropper ref="cropper"
                      :img="option.img"
                      :outputSize="option.outputSize"
                      :outputType="option.outputType"
                      :canScale="option.canScale"
                      :autoCrop="option.autoCrop"
                      :autoCropWidth="autoCropWidth"
                      :autoCropHeight="autoCropHeight"
                      :canMoveBox="option.canMoveBox"
                      :canMove="option.canMove"
                      :centerBox="option.centerBox"
                      :info="option.info"
                      :fixedBox="option.fixedBox"
                      @realTime="realTime"></vueCropper>
        </div>
      </div>
    </Modal>

    <Modal title="查看图片"
           v-model="visible"
           style="text-align:center"
           :mask-closable="false"
           footer-hide>
      <img class="bigPic"
           :src="$publicData.ossUrl+uploadList_act"
           v-if="visible" />
    </Modal>
    <!-- 加载 -->
    <Spin fix
          v-if="loading">
      <Icon type="ios-loading"
            size="18"
            class="demo-spin-icon-load"></Icon>
    </Spin>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import Compressor from "compressorjs";
export default {
  name: "UploadThumb",
  data () {
    return {
      loading: false,
      visible: false,
      uploadList_act: null, //放大图
      uploadList: [],
      showCai: false,
      target: "",
      option: {
        img: "base64", // 裁剪图片地址
        outputSize: 1, // 裁剪生成图片质量
        outputType: "jepg", // 裁剪生成图片格式
        canScale: true, // 图片是否允许滚轮播放
        autoCrop: true, // 是否默认生成截图框 false
        info: false, // 是否展示截图框信息
        canMoveBox: false, // 截图框是否可以拖动
        fixedBox: true, // 固定截图框的大小
        canMove: true, // 上传图片是否可拖动
        centerBox: false // 截图框限制在图片里面
      },
      // resImg: null, //截图后图片
      previewImg: null, // 预览后的图片
      previewObj: {
        width: 200,
        height: 200
      },
      imgObj: {
        width: 1000,
        height: 750
      },
      tipInfo:
        "上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，请自己处理好宽高比例",
      caiWidth: 116, // 生成截图框的宽度
      caiHeight: 116 // 生成截图框的高度
    };
  },
  // 组件
  components: {
    VueCropper
  },
  props: {
    defaultList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    defaultTip: {
      type: String,
      default: function () {
        return this.tipInfo;
      }
    },
    autoCropWidth: {
      type: Number,
      default: function () {
        return this.caiWidth;
      }
    },
    autoCropHeight: {
      type: Number,
      default: function () {
        return this.caiHeight;
      }
    }
  },
  mounted () { },
  watch: {
    defaultList (curVal, oldVal) {
      if (curVal) {
        this.uploadList = curVal;
        // console.log("defaultList", this.uploadList);
      }
    },
    defaultTip (curVal, oldVal) {
      if (curVal) {
        this.tipInfo = curVal;
      }
    },
    autoCropWidth (curVal, oldVal) {
      if (curVal) {
        this.caiWidth = curVal;
      }
    },
    autoCropHeight (curVal, oldVal) {
      if (curVal) {
        this.caiHeight = curVal;
      }
    }
  },
  created: function () { },
  methods: {
    // 点击放大
    tobig (index) {
      this.uploadList_act = this.uploadList[index].url;
      this.visible = true;
    },
    // 点击删除
    todelect (index) {
      var that = this;
      //   that.uploadList = null;
      that.uploadList.splice(index, 1);
    },
    // 点击取消
    toqu () {
      this.showCai = false;
    },
    // 点击确定
    handleClick () {
      // console.log("handleClick");
      let that = this;
      that.loading = true;
      that.$refs.cropper.getCropData(data => {
        that.$api.common.upload({ imgFile: data }).then(res => {
          that.loading = false;
          if (res.code == 200) {
            var url = res.result.url;
            var obj = {
              url: res.result.url
            };
            that.uploadList.push(obj);
            // this.uploadList = res.result.url;
            // console.log("this.uploadList", that.uploadList);
            that.showCai = false;
          }
        });
      });
    },
    realTime (data) {
      // console.log("realTime");
      const that = this;
      this.$refs.cropper.getCropBlob(data => {
        // 这里data数据为Blob类型，blobToDataURI方法转换成base64
        // console.log(data);
        this.blobToDataURI(data, function (res) {
          that.previewImg = res;
        });
      });
    },
    blobToDataURI (blob, callback) {
      // console.log("blobToDataURI");
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
        callback(e.target.result);
      };
    },
    tofile () {
      this.$refs.uploadFile.setAttribute("type", "file");
    },
    async showImg () {
      // console.log(this.$refs.uploadFile.files)
      // console.log("showImg");
      let that = this;
      var file = this.$refs.uploadFile.files[0];
      console.log("压缩前", file);
      let newFile = await that.$util.imageCompressor(file, "file");
      console.log("压缩后", newFile);
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsDataURL(newFile);
        //监听文件读取结束后事件
        reader.onloadend = function (e) {
          that.target = e.target.result;
        };
      }
      setTimeout(() => {
        // console.log("setTimeout");
        this.option.img = that.target;
        this.showCai = true;
        this.$refs.uploadFile.setAttribute("type", "text");
      }, 1000);
    }
  }
};
</script>


<style scoped>
.upload-thumb {
  display: flex;
}
.ivu-alert {
  max-width: 200px;
  margin-left: 10px;
  margin-top: 10px;
}
.display {
  display: none !important;
}
.op {
  opacity: 0;
}
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.upload-list img {
  width: 100%;
  height: 100%;
}

.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100% !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.6);
}

.upload-list:hover .upload-list-cover {
  display: block;
}
.upload-list .upload-list-cover .i-list {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
  display: block !important;
  width: 25px !important;
  height: 25px !important;
  position: initial !important;
}
.chuan {
  /* position: relative;
  width: 58px;
  height: 58px; */
  display: flex;
  flex-wrap: wrap;
}
.uploadw {
  /* position: absolute; */
  width: 58px;
  height: 58px;
}
.uploadw input {
  position: absolute;
  width: 58px;
  height: 58px;
  z-index: 10;
  opacity: 0;
  cursor: context-menu;
}
.uploadw img {
  position: absolute;
  width: 58px;
  height: 58px;
}
.icon {
  width: 58px;
  height: 58px;
  position: absolute;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 0 2px;
  justify-content: space-between;
  display: none;
}
.icon .ivu-icon {
  font-size: 20px;
  color: #fff;
  line-height: 58px;
  cursor: pointer;
}
.uploadList {
  display: flex;
}
.uploadList .imgList {
  width: 58px;
  height: 58px;
  border: 1px dashed #eee;
  margin-right: 5px;
}
.uploadList img {
  width: 58px;
  height: 58px;
  object-fit: contain;
}
.uploadList .imgList:hover .icon {
  display: flex;
}
.bigPic {
  width: 1000px;
  height: 750px;
  object-fit: contain;
}
/* .cropper-view-box img{
  min-width: 500px;
  height: 500px;
} */
/deep/.ivu-modal-wrap .ivu-modal {
  width: 1032px !important;
  top: 25px;
}
/deep/.ivu-modal-wrap .ivu-modal .ivu-modal-content .ivu-modal-body {
  /* width: 1050px; */
  /* height: 750px; */
}
/deep/.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}
/deep/.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/deep/.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>


<style>
